import * as React from 'react';
import { connect } from 'react-redux';
import { setQuoteData, updateCarCover } from '../../../../actions/salesActions';
import KPInputTextArea from '../../../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import "./AgreedValueBlock.css"

class AgreedValueBlock extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeNumber = this.handleChangeNumber.bind(this);
        this.handleSliderChange = this.handleSliderChange.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleChange(e: any) {
        let value = e.target.value;
        let percentage = Math.round((value / this.props.sales.carDetails.carDetails.currRetailValue - 1) * 100);
        if (value === this.props.sales.carDetails.carDetails.currRetailValue) {
            percentage = 0
        }
        let payload = {
            selectedAgreedValue: value,
            selectedAgreedValuePercentage: percentage,
        }
        await this.props.dispatchAction(setQuoteData(payload));
        await this.checkSubmit();
    }

    async handleChangeNumber(e: any) {
        let value = await e.target.value.replace(this.props.profile.currencySymbol, "").replaceAll(",", "");
        let percentage = Math.round((value / this.props.sales.carDetails.retailValue - 1) * 100);
        if (value === this.props.sales.carDetails.retailValue) {
            percentage = 0
        }
        let payload = {
            selectedAgreedValue: value,
            selectedAgreedValuePercentage: percentage,
        }
        await this.props.dispatchAction(setQuoteData(payload));
        await this.checkSubmit();
    }

    async handleSliderChange(e: any) {
        let percentage = e.target.value;
        let value = ((this.props.sales.carDetails.retailValue * (percentage / 100)) + this.props.sales.carDetails.retailValue).toFixed(2);
        let payload = {
            selectedAgreedValue: value,
            selectedAgreedValuePercentage: percentage,
        }
        await this.props.dispatchAction(setQuoteData(payload));
        await this.checkSubmit();
    }

    async handleSwitch(e: any) {
        var checked = e.target.checked;
        this.props.dispatchAction(updateCarCover(checked,false))
        await this.checkSubmit();
    }

    async handleSubmit() {
        await this.props.dispatchAction(updateCarCover(true,false))
        await this.setState({ nextDisabled: true });
    }

    async checkSubmit() {
        if ((this.props.sales.carDetails.agreedValue ?? null ) !== null && this.props.sales.selectedAgreedValuePercentage >= 0 && this.props.sales.selectedAgreedValuePercentage <= 20 && !(this.props.sales.selectedAgreedValue < this.props.sales.carDetails.retailValue) && !(this.props.sales.selectedAgreedValue == this.props.sales.carDetails.agreedValue.toFixed(2))) {
            await this.setState({ nextDisabled: false });
        } else {
            await this.setState({ nextDisabled: true });
        }
    }
    async componentDidMount() {
        if ((this.props.sales.carDetails.agreedValue ?? null) !== null && this.props.sales.selectedAgreedValuePercentage >= 0 && this.props.sales.selectedAgreedValuePercentage <= 20 && !(this.props.sales.selectedAgreedValue < this.props.sales.carDetails.retailValue) && !(this.props.sales.selectedAgreedValue == this.props.sales.carDetails.agreedValue.toFixed(2))) {
        await this.setState({ nextDisabled: false });
    } else {
        await this.setState({ nextDisabled: true });
    }
}

    public render() {
        let isEnabled = this.props.sales.carDetails.agreedValue !== null;
        return (
            <div className={(isEnabled ? "green-border " : "") + "container content-box-padding-20px"}>
                <div className="col-12 noma nopa">
                    <div className="row noma">
                        <div className="col-6 text-left noma nopa">
                            <h3>Agreed value</h3>
                        </div>
                        <div className="col-6 text-left noma nopa">
                            <div className="form-group noma nopa text-right mr-40px" id='agreed-checkbox'>
                                <div className="switch">
                                    <input type="checkbox" id="isEnabled" name="agreedEnabled" onChange={this.handleSwitch} checked={isEnabled } />
                                    <label className="switch-normal" htmlFor="isEnabled">{isEnabled && "On" || "Off"}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p>The only difference between our agreed value and comprehensive options is that, with agreed value, the insured value that’s noted on your policy schedule is the amount that the car is covered for, for 3 years.</p>
                </div>
                {isEnabled && this.props.sales.carDetails.agreedValue !== null &&
                    <>
                    <hr />
                    <div className="row noma nopa">
                        <div className="text-left noma nopa mr-15px">
                            <div className="col noma nopa">
                                <p><b>Current agreed value</b></p>
                            </div>
                            <div className="col noma nopa">
                                <p className="vehicle-value">{this.props.profile.currencySymbol} {this.props.sales.carDetails.agreedValue?.toFixed(2) ?? ""}</p>
                            </div>
                        </div>
                        <div className="text-left noma nopa mr-15px">
                            <div className="col noma nopa">
                                <p><b>Current retail value</b></p>
                            </div>
                            <div className="col noma nopa">
                                <p className="vehicle-value">{this.props.profile.currencySymbol} {this.props.sales.carDetails.retailValue?.toFixed(2) ?? ""}</p>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <h3><b>Use the text box or slider to adjust your agreed value</b></h3>
                    <p>You can choose an agreed value that’s up to 20% more than the retail value.</p>
                    <div className="row noma nopa w-100">
                        <div className="range col-10 noma nopa" id='agreed-slider'>
                            <input type="range" max={20} className="form-range" name="selectedAgreedValuePercentage" value={this.props.sales.selectedAgreedValuePercentage} onChange={this.handleSliderChange} />
                        </div>
                        <div className="percentage-box col-2 text-center nopa">
                            <p className="mt-10px percentage-text">{this.props.sales.selectedAgreedValuePercentage}%</p>
                        </div>
                    </div>
                    <div className="row noma nopa w-100">
                        <div className="mb-15px col-lg-8 col-m-8 col-sm-12 agreed-input nopa">
                            <KPInputTextArea
                                id="agreedValue"
                                name="agreedAmount"
                                type="currencyinput"
                                className="pr-15px"
                                label={"Agreed value"}
                                alwaysShowLabel={false}
                                value={this.props.sales.selectedAgreedValue}
                                notice={this.state.nextDisabled && (Number(this.props.sales.selectedAgreedValue) != Number(this.props.sales.carDetails.agreedValue))}
                                noticeType={"error"}
                                noticeMessage={"Agreed value can't be more than 20% of retail value or less than retail value"}
                                successTick={false}
                                required={true}
                                readOnly={false}
                                autoFocus={false}
                                minLength={3}
                                maxLength={false}
                                disabled={false}
                                form="mainform"
                                handleChange={(e) => this.handleChangeNumber(e)}
                                currencySymbol={this.props.profile.currencySymbol}
                            />
                        </div>
                        <div className="text-center col-lg-4 col-m-4 col-sm-12 nopa">
                            <button className="btn btn-solid-green w-100 agreed-button" id="updateAgreed" disabled={this.state.nextDisabled} onClick={this.handleSubmit }><span>Update value</span></button>
                        </div>
                    </div>
                    <div className="form-row text-left noma agreed-value-please-note mt-44px">
                        <div className="col-12 nopa">
                            <p className="mb-0px font-weight-bold">Please note:</p>
                        </div>
                        <div className="col-12 nopa">
                            <ul className="mb-0px pl-25px">
                                <li>Your car’s value won’t depreciate, and so your car premium won’t decrease monthly.</li>
                                <li>If you change the agreed value, we’ll use the retail value at that time to calculate your new agreed value. This new agreed value will then apply for 3 years.</li>
                                <li>If you change the agreed value, you can’t then change it back to what it was.</li>
                                <li>Accessories and non-standard fitted extras must be noted on your policy schedule and a separate premium paid for them.</li>
                            </ul>
                        </div>
                    </div>
                </>}
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreedValueBlock);